import { Button, Modal } from 'react-bootstrap';

interface IOwnProps {
  title?: string;
  children?: React.ReactNode;
  show: boolean;
  handleClose: () => void;
}
export const Alert: React.FC<IOwnProps> = (props: IOwnProps) => {
  return (
    <Modal
      show={props.show}
      onHide={props.handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className='bg-primary-subtle' closeButton>
        <Modal.Title>{props.title ?? 'Alert'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.handleClose}>Okay</Button>
      </Modal.Footer>
    </Modal>
  );
};